export const faqs = [
  {
    q: 'È adatto anche a chi è alle prime esperienze?',
    a: [
      'Sì. Il sistema è organizzato in modo progressivo, partendo dalle fondamenta e passando attraverso le diverse fasi fino alla preparazione della gara.',
      'Non è necessario essere già un triatleta esperto per comprendere la struttura del metodo.',
    ],
  },
  {
    q: 'Ho bisogno di un allenatore per utilizzare il sistema?',
    a: [
      'Il materiale è progettato per aiutarti a organizzare la preparazione in modo più strutturato. Non è un servizio di coaching individuale e non sostituisce una valutazione professionale personalizzata.',
      'Se hai esigenze specifiche, considera il supporto di un allenatore qualificato.',
    ],
  },
  {
    q: 'Devo avere accesso a una palestra?',
    a: [
      'Il sistema è un metodo digitale per organizzare la preparazione al triathlon. Le esigenze di attrezzatura dipendono dal tuo programma, dalle discipline che pratichi e dalle condizioni in cui ti alleni.',
    ],
  },
  {
    q: 'È un libro fisico?',
    a: [
      'No. IL SISTEMA TRIATHLON FULL DISTANCE™ è un prodotto digitale in formato PDF.',
      'Puoi consultarlo sui dispositivi compatibili senza attendere una spedizione fisica.',
    ],
  },
  {
    q: 'Si tratta di un pagamento unico?',
    a: [
      'Sì. Il prezzo indicato è un pagamento unico, non un abbonamento ricorrente.',
      "L'accesso ai materiali acquistati è a vita, secondo le condizioni del servizio.",
    ],
  },
  {
    q: 'Come riceverò il materiale?',
    a: [
      "Dopo aver completato l'acquisto, potrai accedere ai materiali digitali secondo le istruzioni fornite nella pagina di conferma e nella comunicazione di accesso.",
    ],
  },
  {
    q: 'I quattro bonus sono inclusi?',
    a: [
      "Sì. Nell'offerta descritta in questa pagina sono inclusi: Il Calendario di Allenamento Triathlon 40 Settimane™, La Guida Pratica all’Alimentazione del Triatleta™, La Checklist della Settimana di Gara™ e Il Diario di Progressione del Triatleta™.",
    ],
  },
  {
    q: 'Posso utilizzare il sistema su Android e iOS?',
    a: ['Sì. Puoi consultare i PDF su smartphone, tablet e computer compatibili con la lettura dei documenti PDF.'],
  },
  {
    q: 'È un servizio di coaching personalizzato?',
    a: [
      'No. È un sistema digitale educativo e organizzativo.',
      'Non comprende allenamenti individuali supervisionati, valutazioni fisiche personalizzate o assistenza continuativa da parte di un allenatore.',
    ],
  },
];

export const steps = [
  {
    n: '1',
    title: 'Scarica subito il sistema',
    body: 'Acquista IL SISTEMA TRIATHLON FULL DISTANCE™ e accedi ai materiali digitali delle sei fasi e ai quattro bonus inclusi. Nessuna spedizione. Nessuna attesa per la consegna fisica. Inizia quando sei pronto.',
    tags: [] as string[],
    after: '',
  },
  {
    n: '2',
    title: 'Organizza il tuo sistema di allenamento',
    body: 'Utilizza le sei fasi per organizzare la preparazione e considerare insieme:',
    tags: ['Nuoto', 'Ciclismo', 'Corsa', 'Lavoro complementare', 'Recupero', 'Alimentazione e idratazione', 'Progressi'],
    after: 'Invece di chiederti continuamente “Cosa dovrei fare adesso?”, avrai una struttura di riferimento da consultare durante il percorso.',
  },
  {
    n: '3',
    title: 'Preparati a gestire la gara',
    body: 'Man mano che la competizione si avvicina, utilizza gli strumenti inclusi per organizzare:',
    tags: ['La preparazione', "L'alimentazione", 'I progressi', "L'attrezzatura", 'La settimana della gara', 'La strategia di gara'],
    after: '',
  },
];
